import React from "react";

export const useFocus = (): [React.RefObject<HTMLInputElement>, () => void] => {
  const htmlElRef = React.useRef<HTMLInputElement | null>(null);
  const setFocus = () => {
    htmlElRef.current && htmlElRef.current.focus();
  };

  return [htmlElRef, setFocus];
};
